(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.blockCardEmbed = {
    attach: function (context, settings) {
      $(once('reveal-blocks', '.component-block-embed-card')).each(function () {
        var blockToDisplay = $(this).find('.block');
        var grandParent = $(this).parents('.section--content');
        var field = $(this).find('.field--name-field-block-embed-reference');
        // var paragraphId = $(this).data('entity-id');
        // $(block).attr('paragraph-id', paragraphId);

        $(window).resize(function () {
          if (window.matchMedia('(max-width: 767px)').matches) {
            if ($(blockToDisplay).hasClass('desktop-block')) {
              $(blockToDisplay).removeClass('desktop-block');
              $(blockToDisplay).appendTo(field);
            }
          }
          else {
            $(blockToDisplay).addClass('desktop-block');
            $(blockToDisplay).appendTo(grandParent);
          }
        });

        if (window.matchMedia('(max-width: 767px)').matches) {
          if ($(blockToDisplay).hasClass('desktop-block')) {
            $(blockToDisplay).removeClass('desktop-block');
            $(blockToDisplay).appendTo(field);
          }
        }
        else {
          $(blockToDisplay).addClass('desktop-block');
          $(blockToDisplay).appendTo(grandParent);
        }


        $(this).find('.component-block-embed-card__container').on('click', function () {
          var parent = $(this).parent();
          if ($(blockToDisplay).hasClass('active')) {
            $(parent).removeClass('active');
            $(blockToDisplay).removeClass('active');
            $('.block').not(blockToDisplay).removeClass('active');
            $('.component-block-embed-card').not(parent).removeClass('active');
          }
          else {
            $(blockToDisplay).addClass('active');
            $(parent).addClass('active');
            $('.block').not(blockToDisplay).removeClass('active');
            $('.component-block-embed-card').not(parent).removeClass('active');
          }

          // Scroll to the open area when a card is clicked.
          $([document.documentElement, document.body]).animate({
            scrollTop: $(blockToDisplay).offset().top
          }, 1000);

        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef



